// extracted by mini-css-extract-plugin
module.exports = {"Background":"SideNavMenu_Background__3k6ho"};